const styles = (theme) => ({
  container: { display: "flex", flexDirection: "column", gap: 1 },
  statusPaper: {
    display: "flex",
    width: "100%",
    height: "100%",
    borderRadius: 4,
    flexDirection: "column",
    p: 2,
    position: "relative",
    overflow: "hidden",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    left: 0,
  },
  boxStatus: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  statusTitle: {
    fontWeight: 500,
    fontSize: "20px",

    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  statusContent: {
    display: "flex",
    height: "100%",
    width: "100%",
  },
  customTooltip: {
    bgcolor: theme.palette.cardGraphic.graphColor["green"],
    width: "14px",
    height: "14px",
    borderRadius: "2px",
    border: `1px solid ${theme.palette.cardGraphic.graphColor["green"]}`,
  },
  boxTooltip: {
    bgcolor: theme.palette.paletteCharts.lineCharts,
    padding: "8px",
    borderRadius: "8px",
  },
});

export default styles;
